export default "__VITE_ASSET__4c145aff__"